// import React, { useState, useEffect } from 'react';
// import './AddBookType.css';
// import * as Constants from '../../Constant/constant';
// function AddBookType() {
   
//     const [bookTypeName, setBookTypeName] = useState('');
//     const [prefix, setPrefix] = useState('');
//     const [bookTypes, setBookTypes] = useState([]);
//     const [loadingBookTypes, setLoadingBookTypes] = useState(true);
//     const [errorBookTypes, setErrorBookTypes] = useState('');
//     const [editingBookTypeId, setEditingBookTypeId] = useState(null);
//     const [editedBookTypeName, setEditedBookTypeName] = useState('');
//     const [editedPrefix, setEditedPrefix] = useState('');

//     // Fetch book types when the component mounts
//     useEffect(() => {
//         const fetchBookTypes = async () => {
//             setLoadingBookTypes(true);
//             setErrorBookTypes('');

//             try {
//                 const response = await fetch(Constants.API_PATH +`/book_type_data`); // Replace with your API endpoint
//                 if (!response.ok) {
//                     throw new Error('Failed to fetch book types');
//                 }
//                 const data = await response.json();
//                 setBookTypes(data);
//             } catch (error) {
//                 setErrorBookTypes(error.message);
//             } finally {
//                 setLoadingBookTypes(false);
//             }
//         };

//         fetchBookTypes();
//     }, []);

//     const handleUpdateBookType = async (id) => {
//         try {
//             const response = await fetch(Constants.API_PATH + '/book-types/${id}', { // Replace with your API endpoint
//                 method: 'PUT',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     name: editedBookTypeName,
//                     prefix: editedPrefix,
//                 }),
//             });

//             if (!response.ok) {
//                 throw new Error('Failed to update book type');
//             }

//             // Refresh the book types after updating
//             const updatedBookTypes = bookTypes.map((bookType) =>
//                 bookType.id === id ? { ...bookType, name: editedBookTypeName, prefix: editedPrefix } : bookType
//             );
//             setBookTypes(updatedBookTypes);
//             handleCancelEdit(); // Reset editing state
//         } catch (error) {
//             setErrorBookTypes(error.message);
//         }
//     };

//     const handleDeleteBookType = async (id) => {
//         try {
//             const response = await fetch(Constants.API_PATH +'/delete_book/${id}', { // Replace with your API endpoint
//                 method: 'DELETE',
//             });

//             if (!response.ok) {
//                 throw new Error('Failed to delete book type');
//             }

//             // Remove the deleted book type from the state
//             setBookTypes(bookTypes.filter((bookType) => bookType.id !== id));
//         } catch (error) {
//             setErrorBookTypes(error.message);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(Constants.API_PATH +'/add_book_type', { // Replace with your API endpoint
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({ book_type_name: bookTypeName, prefix: prefix }),
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             // Optimistically update the UI (or refetch the data)
//             const newBookType = await response.json(); // Assuming your API returns the newly created object
//             setBookTypes([...bookTypes, newBookType]);

//             setBookTypeName('');
//             setPrefix('');
//         } catch (e) {
//             setErrorBookTypes(e.message);
//             console.error("Could not post the data: " + e);
//         }
//     };

//     const handleCancelEdit = () => {
//         setEditingBookTypeId(null);
//         setEditedBookTypeName('');
//         setEditedPrefix('');
//     };

//     const handleEditBookType = (bookType) => {
//         setEditingBookTypeId(bookType.id);
//         setEditedBookTypeName(bookType.name);
//         setEditedPrefix(bookType.prefix);
//     };

//     if (loadingBookTypes) {
//         return <div>Loading book types...</div>;
//     }

//     if (errorBookTypes) {
//         return <div>Error: {errorBookTypes}</div>;
//     }
//     console.log("ratna")
//     return (
//         <div className="add-book-type-container containernew">
//             <h2 className="add-book-type-heading">Add Book Type</h2>
//             <div className="add-book-type-form-container">
//                 <form onSubmit={handleSubmit}>
//                     <div className="form-group">
//                         <label htmlFor="bookTypeName">Book Type Name*</label>
//                         <input
//                             type="text"
//                             id="bookTypeName"
//                             className="form-control"
//                             value={bookTypeName}
//                             onChange={(e) => setBookTypeName(e.target.value)}
//                             required
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label htmlFor="prefix">Prefix</label>
//                         <input
//                             type="text"
//                             id="prefix"
//                             className="form-control"
//                             value={prefix}
//                             onChange={(e) => setPrefix(e.target.value)}
//                         />
//                     </div>
//                     <button type="submit" className="add-button">
//                         Add
//                     </button>
//                 </form>
//             </div>

//             <h3 className="book-types-title">Existing Book Types</h3>
//             {loadingBookTypes && <p className="loading-message">Loading book types...</p>}
//             {errorBookTypes && <p className="error-message">Error loading book types: {errorBookTypes}</p>}
//             {!loadingBookTypes && !errorBookTypes && (
//                 <table className="book-types-table">
//                     <thead>
//                         <tr>
//                             <th>Sr. No.</th>
//                             <th>Name</th>
//                             <th>Prefix</th>
//                             <th>Action</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {bookTypes.map((bookType, index) => (
//                             <tr key={bookType.id}>
//                                 <td>{index + 1}</td>
//                                 <td>
//                                     {editingBookTypeId === bookType.id ? (
//                                         <input
//                                             type="text"
//                                             value={editedBookTypeName}
//                                             onChange={(e) => setEditedBookTypeName(e.target.value)}
//                                         />
//                                     ) : (
//                                         bookType.book_type_name
//                                     )}
//                                 </td>
//                                 <td>
//                                     {editingBookTypeId === bookType.id ? (
//                                         <input
//                                             type="text"
//                                             value={editedPrefix}
//                                             onChange={(e) => setEditedPrefix(e.target.value)}
//                                         />
//                                     ) : (
//                                         bookType.prefix
//                                     )}
//                                 </td>
//                                 <td>
//                                     {editingBookTypeId === bookType.id ? (
//                                         <>
//                                             <button className="edit-button" onClick={() => handleUpdateBookType(bookType.id)}>
//                                                 Update
//                                             </button>
//                                             <button className="delete-button" onClick={handleCancelEdit}>
//                                                 Cancel
//                                             </button>
//                                         </>
//                                     ) : (
//                                         <>
//                                             <button className="edit-button" onClick={() => handleEditBookType(bookType)}>
//                                                 Edit
//                                             </button>
//                                             <button className="delete-button" onClick={() => handleDeleteBookType(bookType.id)}>
//                                                 Delete
//                                             </button>
//                                         </>
//                                     )}
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             )}
//         </div>
//     );
// }

// export default AddBookType;

// import React, { useState, useEffect } from 'react';
// import './AddBookType.css';
// import * as Constants from '../../Constant/constant';

// function AddBookType() {
//     const [bookTypeName, setBookTypeName] = useState('');
//     const [prefix, setPrefix] = useState('');
//     const [bookTypes, setBookTypes] = useState([]);
//     const [loadingBookTypes, setLoadingBookTypes] = useState(true);
//     const [errorBookTypes, setErrorBookTypes] = useState('');
//     const [editingBookTypeId, setEditingBookTypeId] = useState(null);
//     const [editedBookTypeName, setEditedBookTypeName] = useState('');
//     const [editedPrefix, setEditedPrefix] = useState('');

//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 5;

//     const fetchBookTypes = async () => {
//         setLoadingBookTypes(true);
//         setErrorBookTypes('');

//         try {
//             const response = await fetch(Constants.API_PATH + `/book_type_data`);
//             if (!response.ok) {
//                 throw new Error('Failed to fetch book types');
//             }
//             const data = await response.json();
//             setBookTypes(data);
//         } catch (error) {
//             setErrorBookTypes(error.message);
//         } finally {
//             setLoadingBookTypes(false);
//         }
//     };

//     useEffect(() => {
//         fetchBookTypes();
//     }, []);

//     const handleUpdateBookType = async (id) => {
//         try {
//             const response = await fetch(`${Constants.API_PATH}/book-types/${id}`, {
//                 method: 'PUT',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     name: editedBookTypeName,
//                     prefix: editedPrefix,
//                 }),
//             });

//             if (!response.ok) {
//                 throw new Error('Failed to update book type');
//             }

//             fetchBookTypes();
//             handleCancelEdit();
//         } catch (error) {
//             setErrorBookTypes(error.message);
//         }
//     };

//     const handleDeleteBookType = async (id) => {
//         try {
//             const response = await fetch(`${Constants.API_PATH}/delete_book/${id}`, {
//                 method: 'DELETE',
//             });
    
//             if (!response.ok) {
//                 throw new Error('Failed to delete book type');
//             }

//             fetchBookTypes();
//         } catch (error) {
//             setErrorBookTypes(error.message);
//         }
//     };
    

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(Constants.API_PATH + '/add_book_type', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({ book_type_name: bookTypeName, prefix: prefix }),
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             fetchBookTypes();
//             setBookTypeName('');
//             setPrefix('');
//         } catch (e) {
//             setErrorBookTypes(e.message);
//             console.error("Could not post the data: " + e);
//         }
//     };

//     const handleCancelEdit = () => {
//         setEditingBookTypeId(null);
//         setEditedBookTypeName('');
//         setEditedPrefix('');
//     };

//     const handleEditBookType = (bookType) => {
//         setEditingBookTypeId(bookType.id);
//         setEditedBookTypeName(bookType.book_type_name);
//         setEditedPrefix(bookType.prefix);
//     };

//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = bookTypes.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(bookTypes.length / itemsPerPage);

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     if (loadingBookTypes) return <div>Loading book types...</div>;
//     if (errorBookTypes) return <div>Error: {errorBookTypes}</div>;

//     return (
//         <div className="add-book-type-container containernew">
//             <h2 className="add-book-type-heading">Add Book Type</h2>
//             <div className="add-book-type-form-container">
//                 <form onSubmit={handleSubmit}>
//                     <div className="form-group">
//                         <label htmlFor="bookTypeName">Book Type Name*</label>
//                         <input
//                             type="text"
//                             id="bookTypeName"
//                             className="form-control"
//                             value={bookTypeName}
//                             onChange={(e) => setBookTypeName(e.target.value)}
//                             required
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label htmlFor="prefix">Prefix</label>
//                         <input
//                             type="text"
//                             id="prefix"
//                             className="form-control"
//                             value={prefix}
//                             onChange={(e) => setPrefix(e.target.value)}
//                         />
//                     </div>
//                     <button type="submit" className="add-button">Add</button>
//                 </form>
//             </div>

//             <h3 className="book-types-title">Existing Book Types</h3>
//             <table className="book-types-table">
//                 <thead>
//                     <tr>
//                         <th>Sr. No.</th>
//                         <th>Name</th>
//                         <th>Prefix</th>
//                         <th>Action</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {currentItems.map((bookType, index) => (
//                         <tr key={bookType.id}>
//                             <td>{indexOfFirstItem + index + 1}</td>
//                             <td>
//                                 {editingBookTypeId === bookType.id ? (
//                                     <input
//                                         type="text"
//                                         value={editedBookTypeName}
//                                         onChange={(e) => setEditedBookTypeName(e.target.value)}
//                                     />
//                                 ) : (
//                                     bookType.book_type_name
//                                 )}
//                             </td>
//                             <td>
//                                 {editingBookTypeId === bookType.id ? (
//                                     <input
//                                         type="text"
//                                         value={editedPrefix}
//                                         onChange={(e) => setEditedPrefix(e.target.value)}
//                                     />
//                                 ) : (
//                                     bookType.prefix
//                                 )}
//                             </td>
//                             <td>
//                                 {editingBookTypeId === bookType.id ? (
//                                     <>
//                                         <button className="edit-button" onClick={() => handleUpdateBookType(bookType.id)}>Update</button>
//                                         <button className="delete-button" onClick={handleCancelEdit}>Cancel</button>
//                                     </>
//                                 ) : (
//                                     <>
//                                         <button className="edit-button" onClick={() => handleEditBookType(bookType)}>Edit</button>
//                                         <button className="delete-button" onClick={() => handleDeleteBookType(bookType.id)}>Delete</button>
//                                     </>
//                                 )}
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>

//             {/* Pagination */}
//             <div className="pagination">
//                 {[...Array(totalPages)].map((_, index) => (
//                     <button
//                         key={index + 1}
//                         className={currentPage === index + 1 ? 'active' : ''}
//                         onClick={() => paginate(index + 1)}
//                     >
//                         {index + 1}
//                     </button>
//                 ))}
//             </div>
//         </div>
//     );
// }

// export default AddBookType;

import React, { useState, useEffect } from 'react';
import './AddBookType.css';
import * as Constants from '../../Constant/constant';

function AddBookType() {
    const [bookTypeName, setBookTypeName] = useState('');
    const [prefix, setPrefix] = useState('');
    const [bookTypes, setBookTypes] = useState([]);
    const [loadingBookTypes, setLoadingBookTypes] = useState(true);
    const [errorBookTypes, setErrorBookTypes] = useState('');
    const [editingBookTypeId, setEditingBookTypeId] = useState(null);
    const [editedBookTypeName, setEditedBookTypeName] = useState('');
    const [editedPrefix, setEditedPrefix] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const [showModal, setShowModal] = useState(false);

    const fetchBookTypes = async () => {
        setLoadingBookTypes(true);
        setErrorBookTypes('');
        try {
            const response = await fetch(Constants.API_PATH + `/book_type_data`);
            if (!response.ok) throw new Error('Failed to fetch book types');
            const data = await response.json();
            setBookTypes(data);
        } catch (error) {
            setErrorBookTypes(error.message);
        } finally {
            setLoadingBookTypes(false);
        }
    };

    useEffect(() => {
        fetchBookTypes();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(Constants.API_PATH + '/add_book_type', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ book_type_name: bookTypeName, prefix: prefix }),
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            fetchBookTypes();
            setBookTypeName('');
            setPrefix('');
            setShowModal(false);
        } catch (e) {
            setErrorBookTypes(e.message);
            console.error("Could not post the data: " + e);
        }
    };

    const handleUpdateBookType = async (id) => {
        try {
            const response = await fetch(`${Constants.API_PATH}/update_book_type/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ book_type_name: editedBookTypeName, prefix: editedPrefix }),
            });
            if (!response.ok) throw new Error('Failed to update book type');
            fetchBookTypes();
            handleCancelEdit();
        } catch (error) {
            setErrorBookTypes(error.message);
        }
    };

    const handleDeleteBookType = async (id) => {
        try {
            const response = await fetch(`${Constants.API_PATH}/delete_book/${id}`, {
                method: 'DELETE',
            });
            if (!response.ok) throw new Error('Failed to delete book type');
            fetchBookTypes();
        } catch (error) {
            setErrorBookTypes(error.message);
        }
    };

    const handleEditBookType = (bookType) => {
        setEditingBookTypeId(bookType.id);
        setEditedBookTypeName(bookType.book_type_name);
        setEditedPrefix(bookType.prefix);
    };

    const handleCancelEdit = () => {
        setEditingBookTypeId(null);
        setEditedBookTypeName('');
        setEditedPrefix('');
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = bookTypes.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(bookTypes.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    if (loadingBookTypes) return <div>Loading book types...</div>;
    if (errorBookTypes) return <div>Error: {errorBookTypes}</div>;

    return (
        <div className="add-book-type-container containernew">
            <h2 className="add-book-type-heading">Book Types</h2>

            <button className="add-button" onClick={() => setShowModal(true)}>+ Add Book Type</button>

            {/* Modal */}
            {showModal && (
                <div className="modal-backdrop">
                    <div className="modal-box">
                        <form onSubmit={handleSubmit}>
                            <h4>Add Book Type</h4>
                            <div className="form-group">
                                <label htmlFor="bookTypeName">Book Type Name*</label>
                                <input
                                    type="text"
                                    id="bookTypeName"
                                    className="form-control"
                                    value={bookTypeName}
                                    onChange={(e) => setBookTypeName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="prefix">Prefix</label>
                                <input
                                    type="text"
                                    id="prefix"
                                    className="form-control"
                                    value={prefix}
                                    onChange={(e) => setPrefix(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="add-button">Save</button>
                                <button type="button" className="cancel-button" onClick={() => setShowModal(false)}>Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <table className="book-types-table custom-table">
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Genre</th>
                        <th>Prefix</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((bookType, index) => (
                        <tr key={bookType.id}>
                            <td>{indexOfFirstItem + index + 1}</td>
                            <td>
                                {editingBookTypeId === bookType.id ? (
                                    <input
                                        type="text"
                                        value={editedBookTypeName}
                                        onChange={(e) => setEditedBookTypeName(e.target.value)}
                                    />
                                ) : (
                                    bookType.book_type_name
                                )}
                            </td>
                            <td>
                                {editingBookTypeId === bookType.id ? (
                                    <input
                                        type="text"
                                        value={editedPrefix}
                                        onChange={(e) => setEditedPrefix(e.target.value)}
                                    />
                                ) : (
                                    bookType.prefix
                                )}
                            </td>
                            <td>
                                {editingBookTypeId === bookType.id ? (
                                    <>
                                        <button type="button" className="edit-button" onClick={() => handleUpdateBookType(bookType.id)}>Update</button>
                                        <button type="button" className="delete-button" onClick={handleCancelEdit}>Cancel</button>
                                    </>
                                ) : (
                                    <>
                                        <button type="button" className="edit-button" onClick={() => handleEditBookType(bookType)}>Edit</button>
                                        <button type="button" className="delete-button" onClick={() => handleDeleteBookType(bookType.id)}>Delete</button>
                                    </>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Pagination */}
            <div className="pagination">
                {[...Array(totalPages)].map((_, index) => (
                    <button
                        key={index + 1}
                        className={currentPage === index + 1 ? 'active' : ''}
                        onClick={() => paginate(index + 1)}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default AddBookType;
